/* JIMMY · choix de l'offre, compte à rebours, avis dépliables, barre d'achat fixe */
(function () {
  function initBundles(root) {
    root.querySelectorAll('[data-jimmy-bundle]').forEach(function (bundle) {
      if (bundle.dataset.ready) return;
      bundle.dataset.ready = '1';
      var formId = bundle.dataset.formId;

      function apply(input) {
        bundle.querySelectorAll('.jimmy-bundle__card').forEach(function (card) {
          card.classList.toggle('is-selected', card.contains(input));
        });
        document.querySelectorAll('form[id="' + formId + '"] input[name="id"], input[name="id"][form="' + formId + '"]').forEach(function (idInput) {
          idInput.value = input.value;
          idInput.disabled = false;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
        // Les prix affichés (sous le titre, barre mobile) suivent le palier choisi.
        var card = input.closest('.jimmy-bundle__card');
        if (card) {
          document.querySelectorAll('[data-jimmy-price-now]').forEach(function (el) { el.textContent = card.dataset.price; });
          document.querySelectorAll('[data-jimmy-price-compare]').forEach(function (el) {
            el.textContent = card.dataset.compare;
            el.hidden = !card.dataset.compare;
          });
        }
        document.dispatchEvent(new CustomEvent('jimmy:bundle-change', { detail: { variantId: input.value } }));
      }

      bundle.addEventListener('change', function (event) {
        if (event.target.matches('input[type="radio"]')) apply(event.target);
      });
      var checked = bundle.querySelector('input[type="radio"]:checked');
      if (checked) apply(checked);
    });
  }

  function parseEnd(value) {
    // « AAAA-MM-JJ HH:MM » lu comme heure de Paris (UTC+1 en hiver, UTC+2 en été)
    var m = (value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    if (!m) return null;
    var asUtc = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    var parisOffset = new Date(asUtc).toLocaleString('en-US', { timeZone: 'Europe/Paris', timeZoneName: 'shortOffset' }).match(/GMT([+-]\d+)/);
    var hours = parisOffset ? parseInt(parisOffset[1], 10) : 1;
    return asUtc - hours * 3600 * 1000;
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function initCountdowns(root) {
    root.querySelectorAll('[data-jimmy-countdown]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var end = parseEnd(el.dataset.end);
      var out = el.querySelector('[data-jimmy-countdown-time]');
      if (!end || !out) { el.hidden = true; return; }
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          out.textContent = el.dataset.ended || '';
          el.classList.add('is-ended');
          return;
        }
        var d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), mi = Math.floor((left % 3600) / 60), s = left % 60;
        out.textContent = (d > 0 ? d + 'j ' : '') + pad(h) + ':' + pad(mi) + ':' + pad(s);
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  function initReviews(root) {
    root.querySelectorAll('[data-jimmy-review-more]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      var text = btn.previousElementSibling;
      if (text && text.scrollHeight <= text.clientHeight + 2) { btn.hidden = true; return; }
      btn.addEventListener('click', function () {
        var open = text.classList.toggle('is-open');
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      });
    });
  }

  function initSticky(root) {
    root.querySelectorAll('[data-jimmy-sticky]').forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      var target = document.querySelector('product-form, .product-form');
      if (!target) return;
      // Visible dès que le bouton d'achat est passé au-dessus de l'écran.
      var update = function () { bar.classList.toggle('is-visible', target.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', update, { passive: true });
      update();
      bar.querySelector('[data-jimmy-sticky-button]').addEventListener('click', function () {
        var btn = document.querySelector('product-form button[type="submit"], .product-form__submit');
        if (btn) btn.click();
      });
    });
  }

  function initSliders(root) {
    root.querySelectorAll('[data-jimmy-slider]').forEach(function (slider) {
      if (slider.dataset.ready) return;
      slider.dataset.ready = '1';
      var track = slider.querySelector('.jimmy-slider__track');
      function step(dir) {
        var item = track.firstElementChild;
        var w = item ? item.getBoundingClientRect().width + 16 : track.clientWidth;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      var prev = slider.querySelector('[data-jimmy-prev]');
      var next = slider.querySelector('[data-jimmy-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  function initAll(root) {
    initSliders(root);
    initBundles(root);
    initCountdowns(root);
    initReviews(root);
    initSticky(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
